import { ServicioDTO } from "../servicio.dto";
import { BaseResponseDTO } from "./base.response.dto";

export class GetListaServiciosResponseDTO extends BaseResponseDTO {

    success: boolean;
    msg: string;
    data: {
      hasNext: boolean;
      hasPrev: boolean;
      pageIndex: number;
      pageSize: number;
      totalPageCount: number;
      totalRowCount: number;
      list: Array<ServicioDTO>;
    }
  
  }
  